module.exports = __webpack_public_path__ + "static/media/001-tea.59a41bbf.svg";